import { render, staticRenderFns } from "./XhUserCell.vue?vue&type=template&id=5bdc6517&scoped=true"
import script from "./XhUserCell.vue?vue&type=script&lang=js"
export * from "./XhUserCell.vue?vue&type=script&lang=js"
import style0 from "./XhUserCell.vue?vue&type=style&index=0&id=5bdc6517&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdc6517",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bdc6517')) {
      api.createRecord('5bdc6517', component.options)
    } else {
      api.reload('5bdc6517', component.options)
    }
    module.hot.accept("./XhUserCell.vue?vue&type=template&id=5bdc6517&scoped=true", function () {
      api.rerender('5bdc6517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhUserCell.vue"
export default component.exports